export default {
    TICKET_TYPE_ID: 1,
    TICKET_AUTH_STATUS_ID: 1,
    TICKET_STATUS_ID: 0,
    PREAUTH: true,
};